import React from 'react';

/**
 * Vertical flex column layout primitive.
 * @param {React.HTMLAttributes<HTMLDivElement> & {
 *   gap?: number | string;
 *   align?: string;
 *   justify?: string;
 *   children?: React.ReactNode;
 * }} props
 */
const Stack = ({ gap, align, justify, style, children, ...rest }) => (
  <div
    style={{
      display: 'flex',
      flexDirection: 'column',
      ...(gap != null && { gap }),
      ...(align != null && { alignItems: align }),
      ...(justify != null && { justifyContent: justify }),
      ...style,
    }}
    {...rest}
  >
    {children}
  </div>
);

export default Stack;
